// extracted by mini-css-extract-plugin
export default {"iconBtn":"IconBtn_iconBtn__LTesx"};